// @flow
export const BoardingScreenAction = () => {
  return (dispatch) => {
    dispatch({ type: "CLOSE_DIALOG" });
  };
};
